import { useEffect } from 'react'
import { useLocation } from 'react-router'
import { installKeyboardSwipeDismiss } from './keyboardSwipe'

/** Весь Mini App, включая порталы. Новая запись истории отменяет незавершённый жест. */
export function useKeyboardSwipeDismiss(): void {
  const { key } = useLocation()
  useEffect(() => installKeyboardSwipeDismiss(), [key])
}
